export default "__VITE_ASSET__Dcth8VZZ__"